const SESSION_KEY = 'ZY_PORTAL_SESSION'
const AUTH_EVENT = 'zy-auth-changed'

function emitAuthChange() {
  if (typeof window !== 'undefined') {
    window.dispatchEvent(new Event(AUTH_EVENT))
  }
}

export function getSession() {
  if (typeof window === 'undefined') {
    return null
  }

  const rawValue = window.localStorage.getItem(SESSION_KEY)
  if (!rawValue) {
    return null
  }

  try {
    return JSON.parse(rawValue)
  } catch (error) {
    window.localStorage.removeItem(SESSION_KEY)
    return null
  }
}

export function setSession(session) {
  if (typeof window === 'undefined') {
    return
  }

  window.localStorage.setItem(SESSION_KEY, JSON.stringify(session))
  emitAuthChange()
}

export function clearSession() {
  if (typeof window === 'undefined') {
    return
  }

  window.localStorage.removeItem(SESSION_KEY)
  emitAuthChange()
}

export function getToken() {
  const session = getSession()
  return session && session.token ? session.token : ''
}

export function isAuthenticated() {
  const session = getSession()
  return Boolean(session && session.token)
}

export function getAuthEventName() {
  return AUTH_EVENT
}

export function maskIdCard(idCard) {
  if (!idCard || idCard.length < 8) {
    return idCard || ''
  }

  return `${idCard.slice(0, 4)}********${idCard.slice(-4)}`
}
